import React from 'react';
import theme from './ConfirmIdentity.module.scss';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/components/Buttons';
import { SimpleCard } from '@/components/Cards';
import { TranslatableText } from '@/types';
import Banner from '@/components/Banner';

interface OwnProps {
    code: string;
    onCodeChange: (code: string) => void;
    message?: TranslatableText;
    onResendClick(): void;
    hasError: boolean;
}

const ConfirmIdentity: React.FC<OwnProps> = ({ code, onCodeChange, message, onResendClick, hasError }) => {
    return (
        <SimpleCard className={theme.container}>
            <h5>
                <Trans>We have sent you an SMS</Trans>
            </h5>
            {message && <p>{message}</p>}
            {hasError && (
                <Banner type="danger">
                    <Trans>The one time code you entered is not correct.</Trans>
                </Banner>
            )}
            <input
                value={code}
                onChange={(e) => {
                    const { value, maxLength } = e.target;
                    const message = value.slice(0, maxLength);
                    onCodeChange(message);
                }}
                type="number"
                maxLength={5}
                className={theme.codeInput}
            />
            <Button onClick={() => onResendClick()} color="link" size="small">
                <Trans>Resend Code</Trans>
            </Button>
        </SimpleCard>
    );
};

export default ConfirmIdentity;
